<template>
	<b-modal id="modal-profile" :title="`${user.name}'s Profile`">
		<span class="close" @click="$bvModal.hide('modal-profile')">
			<x-icon size="1.5x" class="custom-class"></x-icon>
		</span>
		<div class="profile-container">
			<div class="left">
				<img :src="avatar" />
			</div>
			<div class="right">
				<span class="p-small"> Email </span>
				<strong @click="refreshToken">
					<span v-if="user.email">{{ user.email }}</span>
					<span v-else>N/A - Headless setup</span>
				</strong>
				<span class="p-small"> License type </span>
				<strong>
					{{ user.license_type }}
				</strong>
			</div>
		</div>

		<div v-if="isTrial">
			<br />
			<h4>You're on the trial version.</h4>
			<p>
				Right now, you can use all features of UnderlineMe, however you can only
				take 50 notes.<br />
			</p>
			<a class="btn btn-primary" @click="startCheckout">
				Upgrade Account <span class="muted">$2.99/m</span>
			</a>
			<br />
			<br />
			<p class="muted">Upgrade now and take unlimited annotations.</p>
		</div>
	</b-modal>
</template>

<script>
import { XIcon } from 'vue-feather-icons';

import subscribe from '@/components/forms/subscribe.vue';

export default {
	components: {
		XIcon,
		subscribe,
	},
	data: function () {
		var obj = {
			stripe: null,
			lock: false,
			key: '',
			errorMessage: '',
			loading: false,
			sessionId: '',
			publishableKey:
				'pk_test_51HE8UjHQAqGl0SYu7g24DXaXrlQTEJKyAMdIL2xpitAoNZIepPEWPznFqQUfpjqSBxpuDGUfejAhcCQArDSSaYh300yP36YtaH',
			successUrl: 'https://underlineme.com',
			cancelUrl: 'https://underlineme.com',
		};
		return obj;
	},
	computed: {
		isTrial: function () {
			var user = this.user;
			if (user.license_type === 'trial') {
				return true;
			} else {
				return false;
			}
		},
		user: function () {
			return this.$store.getters['user/user'];
		},
		avatar: function () {
			let a = this.$store.getters['user/avatar'];
			return a;
		},
		version: function () {
			return this.$store.getters.version;
		},
	},
	methods: {
		refreshToken: function () {
			this.$store.dispatch('user/refreshToken');
		},
		startCheckout() {
			this.$store.dispatch('user/startCheckout').then((sessionId) => {
				console.log(sessionId);
				this.sessionId = sessionId;
				this.$stripe
					.redirectToCheckout({
						sessionId: sessionId,
					})
					.then(this.onCheckoutSubmit)
					.catch(this.onCheckoutError);
			});
		},
		onCheckoutSubmit: function (e) {
			console.log(e);
		},
		onCheckoutError: function (e) {
			console.log(e);
		},
		onSubmit: function () {},
	},
	mounted: function () {},
};
</script>

<style lang="scss">
#modal-profile___BV_modal_outer_ {
	.profile-container {
		display: flex;
		background-color: rgba(255, 255, 255, 0.1);
		padding: 1rem;
		border-radius: 7px;

		img {
			width: 48px;
			height: 48px;
			object-fit: cover;
			object-position: center center;
			border-radius: 50%;
		}
		.left {
		}
		.right {
			padding-left: 1rem;
			strong {
				margin-top: 0.1rem;
				margin-bottom: 1rem;
				display: flex;
			}
		}
	}
}
</style>
